export const themes = {
    light: 'light',
    dark: 'dark'
}

export const colors = {
    wobo: '#52bad5',                    // WoBo color
    black: 'rgba(0, 0, 0)',             // #000
    white: 'rgba(255, 255, 255)'        // #fff
}